export enum Loggedin {
  SUCCESS = 'Success',
  FAILED = 'Failed',
}

export enum UserRole {
  ADMIN = '1',
  STUDENT = '3',
  TEACHER = '2',
}
export enum AuthType {
  LOGIN = 'login',
  REGISTER = 'register',
  FORGOT_PASSWORD = 'ForgotPassword',
}

export interface Subject {
  subjectCode: string;
  name: string;
}

export const yearOptions = [
  { id: 1, name: '2025' },
  { id: 2, name: '2024' },
  { id: 3, name: '2023' },
  { id: 4, name: '2022' },
  { id: 5, name: '2021' },
  { id: 6, name: '2020' },
  { id: 7, name: '2019' },
  { id: 8, name: '2018' },
  { id: 9, name: '2017' },
  { id: 10, name: '2016' },
  { id: 11, name: '2015' },
  { id: 12, name: '2014' },
  { id: 13, name: '2013' },
  { id: 14, name: '2012' },
  { id: 15, name: '2011' },
  { id: 16, name: '2010' },
  { id: 17, name: '2009' },
  { id: 18, name: '2008' },
  { id: 19, name: '2007' },
  { id: 20, name: '2006' },
  { id: 21, name: '2005' },
  { id: 22, name: '2004' },
  { id: 23, name: '2003' },
  { id: 24, name: '2002' },
  { id: 25, name: '2001' },
  { id: 26, name: '2000' },
];

export const monthOptions = [
  { id: 1, name: 'January' },
  { id: 2, name: 'February' },
  { id: 3, name: 'March' },
  { id: 4, name: 'April' },
  { id: 5, name: 'May' },
  { id: 6, name: 'June' },
  { id: 7, name: 'July' },
  { id: 8, name: 'August' },
  { id: 9, name: 'September' },
  { id: 10, name: 'October' },
  { id: 11, name: 'November' },
  { id: 12, name: 'December' },
];

export const stateOptions = [
  {
    id: 1,
    name: 'Andhra Pradesh',
    cities: [
      { id: 1, name: 'Anakapalle' },
      { id: 2, name: 'Anantapur' },
      { id: 3, name: 'Badvel' },
      { id: 4, name: 'Bapatla' },
      { id: 5, name: 'Bheemunipatnam' },
      { id: 6, name: 'Bhimavaram' },
      { id: 7, name: 'Chilakaluripet' },
      { id: 8, name: 'Chittoor' },
      { id: 9, name: 'Dharmavaram' },
      { id: 10, name: 'Eluru' },
      { id: 11, name: 'Gooty' },
      { id: 12, name: 'Gudivada' },
      { id: 13, name: 'Gudur' },
      { id: 14, name: 'Guntakal' },
      { id: 15, name: 'Guntur' },
      { id: 16, name: 'Hindupur' },
      { id: 17, name: 'Jaggaiahpet' },
      { id: 18, name: 'Kadapa' },
      { id: 19, name: 'Kadiri' },
      { id: 20, name: 'Kakinada' },
      { id: 21, name: 'Kandukur' },
      { id: 22, name: 'Kavali' },
      { id: 23, name: 'Kovvur' },
      { id: 24, name: 'Kurnool' },
      { id: 25, name: 'Madanapalle' },
      { id: 26, name: 'Machilipatnam' },
      { id: 27, name: 'Markapur' },
      { id: 28, name: 'Nandyal' },
      { id: 29, name: 'Narasaraopet' },
      { id: 30, name: 'Nellore' },
      { id: 31, name: 'Nidadavole' },
      { id: 32, name: 'Ongole' },
      { id: 33, name: 'Palakollu' },
      { id: 34, name: 'Parvathipuram' },
      { id: 35, name: 'Peddapuram' },
      { id: 36, name: 'Pithapuram' },
      { id: 37, name: 'Proddatur' },
      { id: 38, name: 'Rajahmundry' },
      { id: 39, name: 'Rajampet' },
      { id: 40, name: 'Rayachoti' },
      { id: 41, name: 'Sattenapalle' },
      { id: 42, name: 'Srikakulam' },
      { id: 43, name: 'Tadepalligudem' },
      { id: 44, name: 'Tadipatri' },
      { id: 45, name: 'Tenali' },
      { id: 46, name: 'Tirupati' },
      { id: 47, name: 'Tuni' },
      { id: 48, name: 'Uravakonda' },
      { id: 49, name: 'Venkatagiri' },
      { id: 50, name: 'Vijayawada' },
      { id: 51, name: 'Vinukonda' },
      { id: 52, name: 'Visakhapatnam' },
      { id: 53, name: 'Vizianagaram' },
      { id: 54, name: 'Yemmiganur' },
      { id: 55, name: 'Yerraguntla' },
    ],
  },
  {
    id: 2,
    name: 'Arunachal Pradesh',
    cities: [
      { id: 1, name: 'Itanagar' },
      { id: 2, name: 'Naharlagun' },
      { id: 3, name: 'Tawang' },
      { id: 4, name: 'Ziro' },
      { id: 5, name: 'Pasighat' },
      { id: 6, name: 'Roing' },
      { id: 7, name: 'Bomdila' },
      { id: 8, name: 'Tezu' },
      { id: 9, name: 'Seppa' },
      { id: 10, name: 'Aalo (Along)' },
      { id: 11, name: 'Daporijo' },
      { id: 12, name: 'Changlang' },
      { id: 13, name: 'Namsai' },
      { id: 14, name: 'Khonsa' },
      { id: 15, name: 'Yingkiong' },
      { id: 16, name: 'Anini' },
      { id: 17, name: 'Koloriang' },
      { id: 18, name: 'Hawai' },
      { id: 19, name: 'Longding' },
      { id: 20, name: 'Basar' },
      { id: 21, name: 'Menchukha' },
      { id: 22, name: 'Ruksin' },
      { id: 23, name: 'Dirang' },
      { id: 24, name: 'Bhalukpong' },
    ],
  },
  {
    id: 3,
    name: 'Assam',
    cities: [
      { id: 1, name: 'Guwahati' },
      { id: 2, name: 'Dispur' },
      { id: 3, name: 'Silchar' },
      { id: 4, name: 'Dibrugarh' },
      { id: 5, name: 'Jorhat' },
      { id: 6, name: 'Nagaon' },
      { id: 7, name: 'Tezpur' },
      { id: 8, name: 'Tinsukia' },
      { id: 9, name: 'Bongaigaon' },
      { id: 10, name: 'Diphu' },
      { id: 11, name: 'Karimganj' },
      { id: 12, name: 'Sivasagar' },
      { id: 13, name: 'Barpeta' },
      { id: 14, name: 'Goalpara' },
      { id: 15, name: 'Dhubri' },
      { id: 16, name: 'Haflong' },
      { id: 17, name: 'Golaghat' },
      { id: 18, name: 'Lakhimpur' },
      { id: 19, name: 'North Lakhimpur' },
      { id: 20, name: 'Kokrajhar' },
      { id: 21, name: 'Rangia' },
      { id: 22, name: 'Mangaldoi' },
      { id: 23, name: 'Morigaon' },
      { id: 24, name: 'Sonari' },
      { id: 25, name: 'Udalguri' },
      { id: 26, name: 'Hojai' },
      { id: 27, name: 'Bilasipara' },
      { id: 28, name: 'Mariani' },
      { id: 29, name: 'Chapar' },
      { id: 30, name: 'Sarupathar' },
      { id: 31, name: 'Bajali' },
      { id: 32, name: 'Majuli' },
      { id: 33, name: 'Dhekiajuli' },
      { id: 34, name: 'Gohpur' },
      { id: 35, name: 'Hailakandi' },
    ],
  },
  {
    id: 4,
    name: 'Bihar',
    cities: [
      { id: 1, name: 'Patna' },
      { id: 2, name: 'Gaya' },
      { id: 3, name: 'Bhagalpur' },
      { id: 4, name: 'Muzaffarpur' },
      { id: 5, name: 'Purnia' },
      { id: 6, name: 'Darbhanga' },
      { id: 7, name: 'Bihar Sharif' },
      { id: 8, name: 'Arrah' },
      { id: 9, name: 'Begusarai' },
      { id: 10, name: 'Katihar' },
      { id: 11, name: 'Munger' },
      { id: 12, name: 'Chhapra' },
      { id: 13, name: 'Sasaram' },
      { id: 14, name: 'Hajipur' },
      { id: 15, name: 'Dehri' },
      { id: 16, name: 'Motihari' },
      { id: 17, name: 'Nawada' },
      { id: 18, name: 'Sitamarhi' },
      { id: 19, name: 'Bettiah' },
      { id: 20, name: 'Siwan' },
      { id: 21, name: 'Jamalpur' },
      { id: 22, name: 'Jehanabad' },
      { id: 23, name: 'Aurangabad' },
      { id: 24, name: 'Gopalganj' },
      { id: 25, name: 'Buxar' },
      { id: 26, name: 'Khagaria' },
      { id: 27, name: 'Madhubani' },
      { id: 28, name: 'Samastipur' },
      { id: 29, name: 'Lakhisarai' },
      { id: 30, name: 'Sheikhpura' },
      { id: 31, name: 'Supaul' },
      { id: 32, name: 'Araria' },
      { id: 33, name: 'Kishanganj' },
      { id: 34, name: 'Madhepura' },
      { id: 35, name: 'Vaishali' },
      { id: 36, name: 'Rohtas' },
      { id: 37, name: 'Nalanda' },
      { id: 38, name: 'Sheohar' },
      { id: 39, name: 'Kaimur' },
      { id: 40, name: 'Banka' },
      { id: 41, name: 'Saharsa' },
      { id: 42, name: 'East Champaran' },
      { id: 43, name: 'West Champaran' },
      { id: 44, name: 'Jamui' },
    ],
  },
  {
    id: 5,
    name: 'Chhattisgarh',
    cities: [
      { id: 1, name: 'Raipur' },
      { id: 2, name: 'Bhilai' },
      { id: 3, name: 'Durg' },
      { id: 4, name: 'Bilaspur' },
      { id: 5, name: 'Korba' },
      { id: 6, name: 'Raigarh' },
      { id: 7, name: 'Ambikapur' },
      { id: 8, name: 'Jagdalpur' },
      { id: 9, name: 'Rajnandgaon' },
      { id: 10, name: 'Mahasamund' },
      { id: 11, name: 'Dhamtari' },
      { id: 12, name: 'Kanker' },
      { id: 13, name: 'Janjgir' },
      { id: 14, name: 'Sakti' },
      { id: 15, name: 'Champa' },
      { id: 16, name: 'Kawardha' },
      { id: 17, name: 'Baloda Bazar' },
      { id: 18, name: 'Bhatapara' },
      { id: 19, name: 'Bijapur' },
      { id: 20, name: 'Dantewada' },
      { id: 21, name: 'Baikunthpur' },
      { id: 22, name: 'Mungeli' },
      { id: 23, name: 'Surajpur' },
      { id: 24, name: 'Balrampur' },
      { id: 25, name: 'Gariaband' },
      { id: 26, name: 'Sukma' },
      { id: 27, name: 'Narayanpur' },
      { id: 28, name: 'Jashpur' },
      { id: 29, name: 'Pathalgaon' },
      { id: 30, name: 'Tilda' },
    ],
  },
  {
    id: 6,
    name: 'Goa',
    cities: [
      { id: 1, name: 'Panaji' },
      { id: 2, name: 'Margao' },
      { id: 3, name: 'Vasco da Gama' },
      { id: 4, name: 'Mapusa' },
      { id: 5, name: 'Ponda' },
      { id: 6, name: 'Bicholim' },
      { id: 7, name: 'Curchorem' },
      { id: 8, name: 'Sanquelim' },
      { id: 9, name: 'Valpoi' },
      { id: 10, name: 'Canacona' },
      { id: 11, name: 'Quepem' },
      { id: 12, name: 'Sanguem' },
    ],
  },
  {
    id: 7,
    name: 'Gujarat',
    cities: [
      { id: 1, name: 'Ahmedabad' },
      { id: 2, name: 'Surat' },
      { id: 3, name: 'Vadodara' },
      { id: 4, name: 'Rajkot' },
      { id: 5, name: 'Gandhinagar' },
      { id: 6, name: 'Bhavnagar' },
      { id: 7, name: 'Jamnagar' },
      { id: 8, name: 'Junagadh' },
      { id: 9, name: 'Anand' },
      { id: 10, name: 'Navsari' },
      { id: 11, name: 'Morbi' },
      { id: 12, name: 'Nadiad' },
      { id: 13, name: 'Mehsana' },
      { id: 14, name: 'Bharuch' },
      { id: 15, name: 'Vapi' },
      { id: 16, name: 'Gandhidham' },
      { id: 17, name: 'Palanpur' },
      { id: 18, name: 'Bhuj' },
      { id: 19, name: 'Porbandar' },
      { id: 20, name: 'Surendranagar' },
      { id: 21, name: 'Dahod' },
      { id: 22, name: 'Amreli' },
      { id: 23, name: 'Botad' },
      { id: 24, name: 'Deesa' },
      { id: 25, name: 'Veraval' },
      { id: 26, name: 'Godhra' },
      { id: 27, name: 'Patan' },
      { id: 28, name: 'Vyara' },
      { id: 29, name: 'Modasa' },
      { id: 30, name: 'Lunawada' },
      { id: 31, name: 'Himmatnagar' },
      { id: 32, name: 'Mandvi' },
      { id: 33, name: 'Chhota Udepur' },
      { id: 34, name: 'Keshod' },
      { id: 35, name: 'Kalol' },
    ],
  },
  {
    id: 8,
    name: 'Haryana',
    cities: [
      { id: 1, name: 'Chandigarh' },
      { id: 2, name: 'Faridabad' },
      { id: 3, name: 'Gurgaon' },
      { id: 4, name: 'Panipat' },
      { id: 5, name: 'Ambala' },
      { id: 6, name: 'Yamunanagar' },
      { id: 7, name: 'Rohtak' },
      { id: 8, name: 'Hisar' },
      { id: 9, name: 'Karnal' },
      { id: 10, name: 'Sonipat' },
      { id: 11, name: 'Panchkula' },
      { id: 12, name: 'Bhiwani' },
      { id: 13, name: 'Sirsa' },
      { id: 14, name: 'Jind' },
      { id: 15, name: 'Bahadurgarh' },
      { id: 16, name: 'Thanesar' },
      { id: 17, name: 'Rewari' },
      { id: 18, name: 'Palwal' },
      { id: 19, name: 'Kaithal' },
      { id: 20, name: 'Mahendragarh' },
      { id: 21, name: 'Charkhi Dadri' },
      { id: 22, name: 'Narnaul' },
      { id: 23, name: 'Fatehabad' },
      { id: 24, name: 'Tohana' },
      { id: 25, name: 'Hansi' },
      { id: 26, name: 'Gohana' },
      { id: 27, name: 'Narwana' },
      { id: 28, name: 'Ratia' },
      { id: 29, name: 'Samalkha' },
      { id: 30, name: 'Pehowa' },
    ],
  },
  {
    id: 9,
    name: 'Himachal Pradesh',
    cities: [
      { id: 1, name: 'Shimla' },
      { id: 2, name: 'Manali' },
      { id: 3, name: 'Dharamshala' },
      { id: 4, name: 'Solan' },
      { id: 5, name: 'Mandi' },
      { id: 6, name: 'Kullu' },
      { id: 7, name: 'Chamba' },
      { id: 8, name: 'Bilaspur' },
      { id: 9, name: 'Nahan' },
      { id: 10, name: 'Hamirpur' },
      { id: 11, name: 'Kangra' },
      { id: 12, name: 'Una' },
      { id: 13, name: 'Palampur' },
      { id: 14, name: 'Keylong' },
      { id: 15, name: 'Sundernagar' },
      { id: 16, name: 'Paonta Sahib' },
      { id: 17, name: 'Rampur' },
      { id: 18, name: 'Kalpa' },
      { id: 19, name: 'Theog' },
      { id: 20, name: 'Rohru' },
      { id: 21, name: 'Karsog' },
      { id: 22, name: 'Dalhousie' },
      { id: 23, name: 'Kinnaur' },
      { id: 24, name: 'Nurpur' },
      { id: 25, name: 'Baijnath' },
      { id: 26, name: 'Joginder Nagar' },
      { id: 27, name: 'Chopal' },
      { id: 28, name: 'Bhuntar' },
      { id: 29, name: 'Banjar' },
      { id: 30, name: 'Sarahan' },
      { id: 31, name: 'Reckong Peo' },
      { id: 32, name: 'Tattapani' },
      { id: 33, name: 'Jubbal' },
      { id: 34, name: 'Kotkhai' },
      { id: 35, name: 'Shillai' },
      { id: 36, name: 'Ghumarwin' },
      { id: 37, name: 'Nagrota Bagwan' },
      { id: 38, name: 'Mehatpur' },
      { id: 39, name: 'Baddi' },
      { id: 40, name: 'Nalagarh' },
      { id: 41, name: 'Parwanoo' },
      { id: 42, name: 'Kandaghat' },
      { id: 43, name: 'Haripurdhar' },
      { id: 44, name: 'Tira Sujanpur' },
      { id: 45, name: 'Bangana' },
      { id: 46, name: 'Nadaun' },
      { id: 47, name: 'Anni' },
      { id: 48, name: 'Janjehli' },
      { id: 49, name: 'Kotli' },
      { id: 50, name: 'Gagret' },
      { id: 51, name: 'Dehra Gopipur' },
      { id: 52, name: 'Bharari' },
      { id: 53, name: 'Nichar' },
      { id: 54, name: 'Sarkaghat' },
      { id: 55, name: 'Dodra Kwar' },
    ],
  },
  {
    id: 10,
    name: 'Jharkhand',
    cities: [
      { id: 1, name: 'Ranchi' },
      { id: 2, name: 'Jamshedpur' },
      { id: 3, name: 'Dhanbad' },
      { id: 4, name: 'Bokaro Steel City' },
      { id: 5, name: 'Hazaribagh' },
      { id: 6, name: 'Deoghar' },
      { id: 7, name: 'Giridih' },
      { id: 8, name: 'Ramgarh' },
      { id: 9, name: 'Medininagar (Daltonganj)' },
      { id: 10, name: 'Chaibasa' },
      { id: 11, name: 'Gumla' },
      { id: 12, name: 'Godda' },
      { id: 13, name: 'Sahibganj' },
      { id: 14, name: 'Lohardaga' },
      { id: 15, name: 'Simdega' },
      { id: 16, name: 'Pakur' },
      { id: 17, name: 'Jhumri Telaiya' },
      { id: 18, name: 'Phusro' },
      { id: 19, name: 'Chakradharpur' },
      { id: 20, name: 'Dumka' },
      { id: 21, name: 'Latehar' },
      { id: 22, name: 'Basukinath' },
      { id: 23, name: 'Tenu dam-cum-Kathhara' },
      { id: 24, name: 'Chatra' },
      { id: 25, name: 'Barhi' },
      { id: 26, name: 'Mihijam' },
      { id: 27, name: 'Saraikela' },
      { id: 28, name: 'Kodarma' },
      { id: 29, name: 'Rajmahal' },
      { id: 30, name: 'Ghatshila' },
      { id: 31, name: 'Bermo' },
      { id: 32, name: 'Chandil' },
      { id: 33, name: 'Barkakana' },
      { id: 34, name: 'Khunti' },
      { id: 35, name: 'Manoharpur' },
      { id: 36, name: 'Garhwa' },
      { id: 37, name: 'Hussainabad' },
      { id: 38, name: 'Mahagama' },
      { id: 39, name: 'Mandu' },
      { id: 40, name: 'Narayanpur' },
    ],
  },
  {
    id: 11,
    name: 'Karnataka',
    cities: [
      { id: 1, name: 'Bengaluru' },
      { id: 2, name: 'Mysuru' },
      { id: 3, name: 'Hubballi' },
      { id: 4, name: 'Dharwad' },
      { id: 5, name: 'Mangaluru' },
      { id: 6, name: 'Belagavi' },
      { id: 7, name: 'Ballari' },
      { id: 8, name: 'Davangere' },
      { id: 9, name: 'Shivamogga' },
      { id: 10, name: 'Tumakuru' },
      { id: 11, name: 'Raichur' },
      { id: 12, name: 'Bidar' },
      { id: 13, name: 'Udupi' },
      { id: 14, name: 'Hassan' },
      { id: 15, name: 'Vijayapura' },
      { id: 16, name: 'Chitradurga' },
      { id: 17, name: 'Chikkamagaluru' },
      { id: 18, name: 'Bagalkot' },
      { id: 19, name: 'Kolar' },
      { id: 20, name: 'Mandya' },
      { id: 21, name: 'Haveri' },
      { id: 22, name: 'Gadag' },
      { id: 23, name: 'Chikkaballapur' },
      { id: 24, name: 'Ramanagara' },
      { id: 25, name: 'Yadgir' },
      { id: 26, name: 'Koppal' },
      { id: 27, name: 'Kodagu (Madikeri)' },
      { id: 28, name: 'Karwar' },
      { id: 29, name: 'Sirsi' },
      { id: 30, name: 'Sagara' },
      { id: 31, name: 'Hospet' },
      { id: 32, name: 'Channapatna' },
      { id: 33, name: 'Bhadravati' },
      { id: 34, name: 'Ranebennur' },
      { id: 35, name: 'Basavakalyan' },
      { id: 36, name: 'Sira' },
      { id: 37, name: 'Gokak' },
      { id: 38, name: 'Harihar' },
      { id: 39, name: 'Nanjangud' },
      { id: 40, name: 'Channarayapatna' },
      { id: 41, name: 'Robertsonpet' },
      { id: 42, name: 'Sankeshwar' },
      { id: 43, name: 'Mulbagal' },
      { id: 44, name: 'Sindhanur' },
      { id: 45, name: 'Mudhol' },
      { id: 46, name: 'Mudalagi' },
      { id: 47, name: 'Athani' },
      { id: 48, name: 'Malavalli' },
      { id: 49, name: 'Gundlupet' },
      { id: 50, name: 'Yelahanka' },
    ],
  },
  {
    id: 12,
    name: 'Kerala',
    cities: [
      { id: 1, name: 'Thiruvananthapuram' },
      { id: 2, name: 'Kochi' },
      { id: 3, name: 'Kozhikode' },
      { id: 4, name: 'Kollam' },
      { id: 5, name: 'Thrissur' },
      { id: 6, name: 'Palakkad' },
      { id: 7, name: 'Alappuzha' },
      { id: 8, name: 'Malappuram' },
      { id: 9, name: 'Kannur' },
      { id: 10, name: 'Kottayam' },
      { id: 11, name: 'Pathanamthitta' },
      { id: 12, name: 'Idukki' },
      { id: 13, name: 'Kasaragod' },
      { id: 14, name: 'Muvattupuzha' },
      { id: 15, name: 'Guruvayur' },
      { id: 16, name: 'Changanassery' },
      { id: 17, name: 'Nedumangad' },
      { id: 18, name: 'Ponnani' },
      { id: 19, name: 'Varkala' },
      { id: 20, name: 'Ottapalam' },
      { id: 21, name: 'Tirur' },
      { id: 22, name: 'Thalassery' },
      { id: 23, name: 'Kanhangad' },
      { id: 24, name: 'Payyannur' },
      { id: 25, name: 'Perinthalmanna' },
      { id: 26, name: 'Kasaragod' },
      { id: 27, name: 'Kayamkulam' },
      { id: 28, name: 'Vaikom' },
      { id: 29, name: 'Adoor' },
      { id: 30, name: 'Kodungallur' },
      { id: 31, name: 'Chalakudy' },
      { id: 32, name: 'Kunnamkulam' },
      { id: 33, name: 'Manjeri' },
      { id: 34, name: 'Pala' },
      { id: 35, name: 'Attingal' },
      { id: 36, name: 'Irinjalakuda' },
      { id: 37, name: 'Thodupuzha' },
      { id: 38, name: 'Paravur' },
      { id: 39, name: 'Mattannur' },
      { id: 40, name: 'Cherthala' },
      { id: 41, name: 'Kottakkal' },
      { id: 42, name: 'Kuthuparamba' },
      { id: 43, name: 'Mannarkkad' },
      { id: 44, name: 'Aluva' },
      { id: 45, name: 'Punalur' },
      { id: 46, name: 'Shoranur' },
      { id: 47, name: 'Piravom' },
      { id: 48, name: 'Mavelikkara' },
      { id: 49, name: 'Thiruvalla' },
      { id: 50, name: 'Nilambur' },
    ],
  },
  {
    id: 13,
    name: 'Madhya Pradesh',
    cities: [
      { id: 1, name: 'Bhopal' },
      { id: 2, name: 'Indore' },
      { id: 3, name: 'Jabalpur' },
      { id: 4, name: 'Gwalior' },
      { id: 5, name: 'Ujjain' },
      { id: 6, name: 'Satna' },
      { id: 7, name: 'Sagar' },
      { id: 8, name: 'Ratlam' },
      { id: 9, name: 'Rewa' },
      { id: 10, name: 'Morena' },
      { id: 11, name: 'Dewas' },
      { id: 12, name: 'Chhindwara' },
      { id: 13, name: 'Khargone' },
      { id: 14, name: 'Vidisha' },
      { id: 15, name: 'Shivpuri' },
      { id: 16, name: 'Mandsaur' },
      { id: 17, name: 'Neemuch' },
      { id: 18, name: 'Singrauli' },
      { id: 19, name: 'Hoshangabad' },
      { id: 20, name: 'Itarsi' },
      { id: 21, name: 'Sehore' },
      { id: 22, name: 'Khandwa' },
      { id: 23, name: 'Betul' },
      { id: 24, name: 'Datia' },
      { id: 25, name: 'Damoh' },
      { id: 26, name: 'Bhind' },
      { id: 27, name: 'Pithampur' },
      { id: 28, name: 'Chhatarpur' },
      { id: 29, name: 'Seoni' },
      { id: 30, name: 'Tikamgarh' },
      { id: 31, name: 'Rajgarh' },
      { id: 32, name: 'Harda' },
      { id: 33, name: 'Shahdol' },
      { id: 34, name: 'Sidhi' },
      { id: 35, name: 'Narsinghpur' },
      { id: 36, name: 'Guna' },
      { id: 37, name: 'Mandla' },
      { id: 38, name: 'Dindori' },
      { id: 39, name: 'Barwani' },
      { id: 40, name: 'Anuppur' },
      { id: 41, name: 'Jhabua' },
      { id: 42, name: 'Alirajpur' },
      { id: 43, name: 'Sheopur' },
      { id: 44, name: 'Shajapur' },
      { id: 45, name: 'Agar Malwa' },
      { id: 46, name: 'Ashoknagar' },
      { id: 47, name: 'Umaria' },
      { id: 48, name: 'Dhar' },
      { id: 49, name: 'Burhanpur' },
      { id: 50, name: 'Balaghat' },
    ],
  },
  {
    id: 14,
    name: 'Maharashtra',
    cities: [
      { id: 1, name: 'Mumbai' },
      { id: 2, name: 'Pune' },
      { id: 3, name: 'Nagpur' },
      { id: 4, name: 'Thane' },
      { id: 5, name: 'Nashik' },
      { id: 6, name: 'Aurangabad' },
      { id: 7, name: 'Solapur' },
      { id: 8, name: 'Amravati' },
      { id: 9, name: 'Kolhapur' },
      { id: 10, name: 'Sangli' },
      { id: 11, name: 'Jalgaon' },
      { id: 12, name: 'Akola' },
      { id: 13, name: 'Latur' },
      { id: 14, name: 'Dhule' },
      { id: 15, name: 'Ahmednagar' },
      { id: 16, name: 'Chandrapur' },
      { id: 17, name: 'Parbhani' },
      { id: 18, name: 'Nanded' },
      { id: 19, name: 'Bhusawal' },
      { id: 20, name: 'Ratnagiri' },
      { id: 21, name: 'Satara' },
      { id: 22, name: 'Beed' },
      { id: 23, name: 'Yavatmal' },
      { id: 24, name: 'Wardha' },
      { id: 25, name: 'Baramati' },
      { id: 26, name: 'Gondia' },
      { id: 27, name: 'Hingoli' },
      { id: 28, name: 'Jalna' },
      { id: 29, name: 'Osmanabad' },
      { id: 30, name: 'Washim' },
      { id: 31, name: 'Bhandara' },
      { id: 32, name: 'Nandurbar' },
      { id: 33, name: 'Palghar' },
      { id: 34, name: 'Gadchiroli' },
      { id: 35, name: 'Sindhudurg' },
      { id: 36, name: 'Raigad' },
      { id: 37, name: 'Buldhana' },
      { id: 38, name: 'Nagothane' },
      { id: 39, name: 'Chiplun' },
      { id: 40, name: 'Panvel' },
      { id: 41, name: 'Karad' },
      { id: 42, name: 'Pandharpur' },
      { id: 43, name: 'Malegaon' },
      { id: 44, name: 'Kalyan-Dombivli' },
      { id: 45, name: 'Ulhasnagar' },
      { id: 46, name: 'Vasai-Virar' },
      { id: 47, name: 'Mira-Bhayandar' },
      { id: 48, name: 'Ambarnath' },
      { id: 49, name: 'Ichalkaranji' },
      { id: 50, name: 'Dombivli' },
    ],
  },
  {
    id: 15,
    name: 'Manipur',
    cities: [
      { id: 1, name: 'Imphal' },
      { id: 2, name: 'Thoubal' },
      { id: 3, name: 'Bishnupur' },
      { id: 4, name: 'Churachandpur' },
      { id: 5, name: 'Kakching' },
      { id: 6, name: 'Ukhrul' },
      { id: 7, name: 'Senapati' },
      { id: 8, name: 'Tamenglong' },
      { id: 9, name: 'Chandel' },
      { id: 10, name: 'Moreh' },
      { id: 11, name: 'Jiribam' },
      { id: 12, name: 'Moirang' },
      { id: 13, name: 'Kangpokpi' },
      { id: 14, name: 'Noney' },
      { id: 15, name: 'Kamjong' },
      { id: 16, name: 'Tengnoupal' },
      { id: 17, name: 'Saikul' },
    ],
  },
  {
    id: 16,
    name: 'Meghalaya',
    cities: [
      { id: 1, name: 'Shillong' },
      { id: 2, name: 'Tura' },
      { id: 3, name: 'Nongstoin' },
      { id: 4, name: 'Jowai' },
      { id: 5, name: 'Baghmara' },
      { id: 6, name: 'Williamnagar' },
      { id: 7, name: 'Resubelpara' },
      { id: 8, name: 'Mairang' },
      { id: 9, name: 'Khliehriat' },
      { id: 10, name: 'Cherrapunji' },
      { id: 11, name: 'Mawkyrwat' },
      { id: 12, name: 'Byrnihat' },
      { id: 13, name: 'Umiam' },
      { id: 14, name: 'Dawki' },
      { id: 15, name: 'Ranikor' },
    ],
  },
  {
    id: 17,
    name: 'Mizoram',
    cities: [
      { id: 1, name: 'Aizawl' },
      { id: 2, name: 'Lunglei' },
      { id: 3, name: 'Saiha' },
      { id: 4, name: 'Champhai' },
      { id: 5, name: 'Kolasib' },
      { id: 6, name: 'Serchhip' },
      { id: 7, name: 'Mamit' },
      { id: 8, name: 'Lawngtlai' },
      { id: 9, name: 'Bairabi' },
      { id: 10, name: 'Saitual' },
      { id: 11, name: 'Khawzawl' },
      { id: 12, name: 'Hnahthial' },
      { id: 13, name: 'North Vanlaiphai' },
      { id: 14, name: 'Thenzawl' },
      { id: 15, name: 'Zawlnuam' },
    ],
  },
  {
    id: 18,
    name: 'Nagaland',
    cities: [
      { id: 1, name: 'Kohima' },
      { id: 2, name: 'Dimapur' },
      { id: 3, name: 'Mokokchung' },
      { id: 4, name: 'Tuensang' },
      { id: 5, name: 'Wokha' },
      { id: 6, name: 'Zunheboto' },
      { id: 7, name: 'Mon' },
      { id: 8, name: 'Phek' },
      { id: 9, name: 'Kiphire' },
      { id: 10, name: 'Longleng' },
      { id: 11, name: 'Peren' },
      { id: 12, name: 'Tseminyu' },
      { id: 13, name: 'Chümoukedima' },
      { id: 14, name: 'Noklak' },
    ],
  },
  {
    id: 19,
    name: 'Odisha',
    cities: [
      { id: 1, name: 'Bhubaneswar' },
      { id: 2, name: 'Cuttack' },
      { id: 3, name: 'Rourkela' },
      { id: 4, name: 'Brahmapur' },
      { id: 5, name: 'Sambalpur' },
      { id: 6, name: 'Puri' },
      { id: 7, name: 'Balasore' },
      { id: 8, name: 'Bhadrak' },
      { id: 9, name: 'Baripada' },
      { id: 10, name: 'Jharsuguda' },
      { id: 11, name: 'Jeypore' },
      { id: 12, name: 'Anugul' },
      { id: 13, name: 'Dhenkanal' },
      { id: 14, name: 'Paradip' },
      { id: 15, name: 'Phulbani' },
      { id: 16, name: 'Berhampur' },
      { id: 17, name: 'Koraput' },
      { id: 18, name: 'Rayagada' },
      { id: 19, name: 'Kendujhar' },
      { id: 20, name: 'Bargarh' },
      { id: 21, name: 'Kendrapara' },
      { id: 22, name: 'Jagatsinghpur' },
      { id: 23, name: 'Malkangiri' },
      { id: 24, name: 'Nabarangpur' },
      { id: 25, name: 'Nuapada' },
      { id: 26, name: 'Sonepur' },
      { id: 27, name: 'Balangir' },
      { id: 28, name: 'Gajapati' },
      { id: 29, name: 'Boudh' },
      { id: 30, name: 'Sundargarh' },
      { id: 31, name: 'Kalahandi' },
      { id: 32, name: 'Mayurbhanj' },
      { id: 33, name: 'Ganjam' },
      { id: 34, name: 'Nayagarh' },
    ],
  },
  {
    id: 20,
    name: 'Punjab',
    cities: [
      { id: 1, name: 'Ludhiana' },
      { id: 2, name: 'Amritsar' },
      { id: 3, name: 'Jalandhar' },
      { id: 4, name: 'Patiala' },
      { id: 5, name: 'Bathinda' },
      { id: 6, name: 'Mohali' },
      { id: 7, name: 'Hoshiarpur' },
      { id: 8, name: 'Pathankot' },
      { id: 9, name: 'Moga' },
      { id: 10, name: 'Firozpur' },
      { id: 11, name: 'Sangrur' },
      { id: 12, name: 'Kapurthala' },
      { id: 13, name: 'Faridkot' },
      { id: 14, name: 'Barnala' },
      { id: 15, name: 'Gurdaspur' },
      { id: 16, name: 'Malerkotla' },
      { id: 17, name: 'Rupnagar' },
      { id: 18, name: 'Fazilka' },
      { id: 19, name: 'Nawanshahr' },
      { id: 20, name: 'Tarn Taran' },
      { id: 21, name: 'Mansa' },
      { id: 22, name: 'Sri Muktsar Sahib' },
    ],
  },
  {
    id: 21,
    name: 'Rajasthan',
    cities: [
      { id: 1, name: 'Jaipur' },
      { id: 2, name: 'Jodhpur' },
      { id: 3, name: 'Udaipur' },
      { id: 4, name: 'Kota' },
      { id: 5, name: 'Bikaner' },
      { id: 6, name: 'Ajmer' },
      { id: 7, name: 'Bhilwara' },
      { id: 8, name: 'Alwar' },
      { id: 9, name: 'Sikar' },
      { id: 10, name: 'Bharatpur' },
      { id: 11, name: 'Sri Ganganagar' },
      { id: 12, name: 'Pali' },
      { id: 13, name: 'Chittorgarh' },
      { id: 14, name: 'Tonk' },
      { id: 15, name: 'Nagaur' },
      { id: 16, name: 'Barmer' },
      { id: 17, name: 'Jhunjhunu' },
      { id: 18, name: 'Dholpur' },
      { id: 19, name: 'Banswara' },
      { id: 20, name: 'Churu' },
      { id: 21, name: 'Jaisalmer' },
      { id: 22, name: 'Hanumangarh' },
      { id: 23, name: 'Dausa' },
      { id: 24, name: 'Sawai Madhopur' },
      { id: 25, name: 'Rajsamand' },
      { id: 26, name: 'Baran' },
      { id: 27, name: 'Bundi' },
      { id: 28, name: 'Karauli' },
      { id: 29, name: 'Jhalawar' },
      { id: 30, name: 'Sirohi' },
      { id: 31, name: 'Pratapgarh' },
      { id: 32, name: 'Neem Ka Thana' },
      { id: 33, name: 'Makrana' },
      { id: 34, name: 'Beawar' },
      { id: 35, name: 'Tijara' },
      { id: 36, name: 'Nokha' },
      { id: 37, name: 'Suratgarh' },
      { id: 38, name: 'Didwana' },
      { id: 39, name: 'Ratangarh' },
      { id: 40, name: 'Sujangarh' },
      { id: 41, name: 'Degana' },
      { id: 42, name: 'Gangapur City' },
      { id: 43, name: 'Phalodi' },
      { id: 44, name: 'Hindaun' },
      { id: 45, name: 'Kishangarh' },
      { id: 46, name: 'Bayana' },
      { id: 47, name: 'Shahpura' },
      { id: 48, name: 'Mandawa' },
      { id: 49, name: 'Kumbhalgarh' },
      { id: 50, name: 'Lachhmangarh' },
      { id: 51, name: 'Jalore' },
      { id: 52, name: 'Balotra' },
      { id: 53, name: 'Nawalgarh' },
      { id: 54, name: 'Raisinghnagar' },
      { id: 55, name: 'Pokhran' },
      { id: 56, name: 'Kota Industrial Area' },
      { id: 57, name: 'Ramganj Mandi' },
      { id: 58, name: 'Fatehpur' },
      { id: 59, name: 'Kaman' },
      { id: 60, name: 'Merta City' },
      { id: 61, name: 'Sambhar Lake' },
      { id: 62, name: 'Pipar City' },
      { id: 63, name: 'Chhabra' },
      { id: 64, name: 'Bari' },
      { id: 65, name: 'Bhiwadi' },
      { id: 66, name: 'Chirawa' },
      { id: 67, name: 'Rajgarh' },
      { id: 68, name: 'Sumerpur' },
      { id: 69, name: 'Pilani' },
      { id: 70, name: 'Bagru' },
      { id: 71, name: 'Nasirabad' },
      { id: 72, name: 'Chaksu' },
      { id: 73, name: 'Kotputli' },
      { id: 74, name: 'Mundwa' },
      { id: 75, name: 'Bhadra' },
      { id: 76, name: 'Mandawar' },
      { id: 77, name: 'Shahabad' },
      { id: 78, name: 'Bansur' },
      { id: 79, name: 'Baran Industrial Area' },
      { id: 80, name: 'Dungarpur' },
      { id: 81, name: 'Bagidora' },
      { id: 82, name: 'Nadbai' },
      { id: 83, name: 'Rajakhera' },
      { id: 84, name: 'Todabhim' },
      { id: 85, name: 'Pachpadra' },
    ],
  },
  {
    id: 22,
    name: 'Sikkim',
    cities: [
      { id: 1, name: 'Gangtok' },
      { id: 2, name: 'Namchi' },
      { id: 3, name: 'Gyalshing' },
      { id: 4, name: 'Mangan' },
      { id: 5, name: 'Rangpo' },
      { id: 6, name: 'Jorethang' },
      { id: 7, name: 'Singtam' },
      { id: 8, name: 'Pakyong' },
      { id: 9, name: 'Ravangla' },
      { id: 10, name: 'Soreng' },
      { id: 11, name: 'Chungthang' },
      { id: 12, name: 'Lachen' },
      { id: 13, name: 'Lachung' },
      { id: 14, name: 'Dentam' },
      { id: 15, name: 'Yangang' },
      { id: 16, name: 'Zuluk' },
      { id: 17, name: 'Yuksom' },
      { id: 18, name: 'Tashiding' },
      { id: 19, name: 'Pelling' },
      { id: 20, name: 'Rinchenpong' },
    ],
  },
  {
    id: 23,
    name: 'Tamil Nadu',
    cities: [
      { id: 1, name: 'Chennai' },
      { id: 2, name: 'Coimbatore' },
      { id: 3, name: 'Madurai' },
      { id: 4, name: 'Tiruchirappalli' },
      { id: 5, name: 'Salem' },
      { id: 6, name: 'Erode' },
      { id: 7, name: 'Tirunelveli' },
      { id: 8, name: 'Vellore' },
      { id: 9, name: 'Thoothukudi' },
      { id: 10, name: 'Dindigul' },
      { id: 11, name: 'Thanjavur' },
      { id: 12, name: 'Ranipet' },
      { id: 13, name: 'Cuddalore' },
      { id: 14, name: 'Kanchipuram' },
      { id: 15, name: 'Kumarapalayam' },
      { id: 16, name: 'Tiruppur' },
      { id: 17, name: 'Nagercoil' },
      { id: 18, name: 'Karaikal' },
      { id: 19, name: 'Karur' },
      { id: 20, name: 'Sivakasi' },
      { id: 21, name: 'Nagapattinam' },
      { id: 22, name: 'Ariyalur' },
      { id: 23, name: 'Kovilpatti' },
      { id: 24, name: 'Pudukkottai' },
      { id: 25, name: 'Virudhunagar' },
      { id: 26, name: 'Tenkasi' },
      { id: 27, name: 'Perambalur' },
      { id: 28, name: 'Theni' },
      { id: 29, name: 'Namakkal' },
      { id: 30, name: 'Krishnagiri' },
      { id: 31, name: 'Ramanathapuram' },
      { id: 32, name: 'Hosur' },
      { id: 33, name: 'Mayiladuthurai' },
      { id: 34, name: 'Udhagamandalam (Ooty)' },
      { id: 35, name: 'Coonoor' },
      { id: 36, name: 'Pollachi' },
      { id: 37, name: 'Ambur' },
      { id: 38, name: 'Tiruvannamalai' },
      { id: 39, name: 'Tirupattur' },
      { id: 40, name: 'Gudiyatham' },
      { id: 41, name: 'Arakkonam' },
      { id: 42, name: 'Manapparai' },
      { id: 43, name: 'Jayankondam' },
      { id: 44, name: 'Kallakurichi' },
      { id: 45, name: 'Vaniyambadi' },
      { id: 46, name: 'Chengalpattu' },
      { id: 47, name: 'Udumalaipettai' },
      { id: 48, name: 'Dharapuram' },
      { id: 49, name: 'Avadi' },
      { id: 50, name: 'Palani' },
    ],
  },
  {
    id: 24,
    name: 'Telangana',
    cities: [
      { id: 1, name: 'Hyderabad' },
      { id: 2, name: 'Warangal' },
      { id: 3, name: 'Nizamabad' },
      { id: 4, name: 'Khammam' },
      { id: 5, name: 'Karimnagar' },
      { id: 6, name: 'Ramagundam' },
      { id: 7, name: 'Mahbubnagar' },
      { id: 8, name: 'Siddipet' },
      { id: 9, name: 'Suryapet' },
      { id: 10, name: 'Nalgonda' },
      { id: 11, name: 'Jagtial' },
      { id: 12, name: 'Miryalaguda' },
      { id: 13, name: 'Adilabad' },
      { id: 14, name: 'Mancherial' },
      { id: 15, name: 'Medak' },
      { id: 16, name: 'Zaheerabad' },
      { id: 17, name: 'Kothagudem' },
      { id: 18, name: 'Vikarabad' },
      { id: 19, name: 'Bodhan' },
      { id: 20, name: 'Kamareddy' },
      { id: 21, name: 'Bhainsa' },
      { id: 22, name: 'Tandur' },
      { id: 23, name: 'Wanaparthy' },
      { id: 24, name: 'Nagarkurnool' },
      { id: 25, name: 'Gadwal' },
      { id: 26, name: 'Narayanpet' },
      { id: 27, name: 'Jangaon' },
      { id: 28, name: 'Bhadrachalam' },
      { id: 29, name: 'Kodad' },
      { id: 30, name: 'Medchal' },
      { id: 31, name: 'Shadnagar' },
      { id: 32, name: 'Narsapur' },
      { id: 33, name: 'Peddapalli' },
      { id: 34, name: 'Bellampalli' },
      { id: 35, name: 'Sangareddy' },
      { id: 36, name: 'Yellandu' },
      { id: 37, name: 'Kagaznagar' },
      { id: 38, name: 'Huzurabad' },
      { id: 39, name: 'Bhupalpally' },
      { id: 40, name: 'Manuguru' },
    ],
  },
  {
    id: 25,
    name: 'Tripura',
    cities: [
      { id: 1, name: 'Agartala' },
      { id: 2, name: 'Udaipur' },
      { id: 3, name: 'Dharmanagar' },
      { id: 4, name: 'Kailashahar' },
      { id: 5, name: 'Ambassa' },
      { id: 6, name: 'Belonia' },
      { id: 7, name: 'Khowai' },
      { id: 8, name: 'Sabroom' },
      { id: 9, name: 'Sonamura' },
      { id: 10, name: 'Bishalgarh' },
      { id: 11, name: 'Teliamura' },
      { id: 12, name: 'Ranirbazar' },
      { id: 13, name: 'Mohanpur' },
      { id: 14, name: 'Jirania' },
      { id: 15, name: 'Melaghar' },
    ],
  },
  {
    id: 26,
    name: 'Uttar Pradesh',
    cities: [
      { id: 1, name: 'Agra' },
      { id: 2, name: 'Aligarh' },
      { id: 3, name: 'Allahabad (Prayagraj)' },
      { id: 4, name: 'Ambedkar Nagar' },
      { id: 5, name: 'Amethi' },
      { id: 6, name: 'Amroha' },
      { id: 7, name: 'Auraiya' },
      { id: 8, name: 'Azamgarh' },
      { id: 9, name: 'Baghpat' },
      { id: 10, name: 'Bahraich' },
      { id: 11, name: 'Ballia' },
      { id: 12, name: 'Balrampur' },
      { id: 13, name: 'Banda' },
      { id: 14, name: 'Barabanki' },
      { id: 15, name: 'Bareilly' },
      { id: 16, name: 'Basti' },
      { id: 17, name: 'Bhadohi' },
      { id: 18, name: 'Bijnor' },
      { id: 19, name: 'Budaun' },
      { id: 20, name: 'Bulandshahr' },
      { id: 21, name: 'Chandauli' },
      { id: 22, name: 'Chitrakoot' },
      { id: 23, name: 'Deoria' },
      { id: 24, name: 'Etah' },
      { id: 25, name: 'Etawah' },
      { id: 26, name: 'Faizabad (Ayodhya)' },
      { id: 27, name: 'Farrukhabad' },
      { id: 28, name: 'Fatehpur' },
      { id: 29, name: 'Firozabad' },
      { id: 30, name: 'Gautam Buddha Nagar (Noida, Greater Noida)' },
      { id: 31, name: 'Ghaziabad' },
      { id: 32, name: 'Ghazipur' },
      { id: 33, name: 'Gonda' },
      { id: 34, name: 'Gorakhpur' },
      { id: 35, name: 'Hamirpur' },
      { id: 36, name: 'Hapur' },
      { id: 37, name: 'Hardoi' },
      { id: 38, name: 'Hathras' },
      { id: 39, name: 'Jalaun' },
      { id: 40, name: 'Jaunpur' },
      { id: 41, name: 'Jhansi' },
      { id: 42, name: 'Kannauj' },
      { id: 43, name: 'Kanpur' },
      { id: 44, name: 'Kasganj' },
      { id: 45, name: 'Kaushambi' },
      { id: 46, name: 'Kushinagar' },
      { id: 47, name: 'Lakhimpur Kheri' },
      { id: 48, name: 'Lalitpur' },
      { id: 49, name: 'Lucknow' },
      { id: 50, name: 'Maharajganj' },
      { id: 51, name: 'Mahoba' },
      { id: 52, name: 'Mainpuri' },
      { id: 53, name: 'Mathura' },
      { id: 54, name: 'Mau' },
      { id: 55, name: 'Meerut' },
      { id: 56, name: 'Mirzapur' },
      { id: 57, name: 'Moradabad' },
      { id: 58, name: 'Muzaffarnagar' },
      { id: 59, name: 'Pilibhit' },
      { id: 60, name: 'Pratapgarh' },
      { id: 61, name: 'Raebareli' },
      { id: 62, name: 'Rampur' },
      { id: 63, name: 'Saharanpur' },
      { id: 64, name: 'Sambhal' },
      { id: 65, name: 'Sant Kabir Nagar' },
      { id: 66, name: 'Shahjahanpur' },
      { id: 67, name: 'Shamli' },
      { id: 68, name: 'Shrawasti' },
      { id: 69, name: 'Siddharthnagar' },
      { id: 70, name: 'Sitapur' },
      { id: 71, name: 'Sonbhadra' },
      { id: 72, name: 'Sultanpur' },
      { id: 73, name: 'Unnao' },
      { id: 74, name: 'Varanasi' },
    ],
  },
  {
    id: 27,
    name: 'Uttarakhand',
    cities: [
      { id: 1, name: 'Dehradun' },
      { id: 2, name: 'Haridwar' },
      { id: 3, name: 'Rishikesh' },
      { id: 4, name: 'Roorkee' },
      { id: 5, name: 'Haldwani' },
      { id: 6, name: 'Nainital' },
      { id: 7, name: 'Almora' },
      { id: 8, name: 'Pithoragarh' },
      { id: 9, name: 'Rudrapur' },
      { id: 10, name: 'Kashipur' },
      { id: 11, name: 'Tehri' },
      { id: 12, name: 'Chamoli' },
      { id: 13, name: 'Bageshwar' },
      { id: 14, name: 'Uttarkashi' },
      { id: 15, name: 'Mussoorie' },
      { id: 16, name: 'Kotdwar' },
      { id: 17, name: 'Pauri' },
      { id: 18, name: 'Champawat' },
      { id: 19, name: 'Sitarganj' },
      { id: 20, name: 'Devprayag' },
    ],
  },
  {
    id: 28,
    name: 'West Bengal',
    cities: [
      { id: 1, name: 'Kolkata' },
      { id: 2, name: 'Asansol' },
      { id: 3, name: 'Siliguri' },
      { id: 4, name: 'Durgapur' },
      { id: 5, name: 'Bardhaman' },
      { id: 6, name: 'Malda' },
      { id: 7, name: 'Kharagpur' },
      { id: 8, name: 'Howrah' },
      { id: 9, name: 'Haldia' },
      { id: 10, name: 'Jalpaiguri' },
      { id: 11, name: 'Darjeeling' },
      { id: 12, name: 'Alipurduar' },
      { id: 13, name: 'Baharampur' },
      { id: 14, name: 'Krishnanagar' },
      { id: 15, name: 'Medinipur' },
      { id: 16, name: 'Purulia' },
      { id: 17, name: 'Bankura' },
      { id: 18, name: 'Cooch Behar' },
      { id: 19, name: 'Raiganj' },
      { id: 20, name: 'Bangaon' },
    ],
  },
  {
    id: 29,
    name: 'Andaman and Nicobar Islands',
    cities: [
      { id: 1, name: 'Port Blair' },
      { id: 2, name: 'Rangat' },
      { id: 3, name: 'Mayabunder' },
      { id: 4, name: 'Diglipur' },
      { id: 5, name: 'Car Nicobar' },
      { id: 6, name: 'Kamorta' },
      { id: 7, name: 'Campbell Bay' },
    ],
  },
  { id: 30, name: 'Chandigarh', cities: [{ id: 1, name: 'Chandigarh' }] },
  {
    id: 31,
    name: 'Dadra and Nagar Haveli and Daman and Diu',
    cities: [
      { id: 1, name: 'Silvassa' }, // Capital of Dadra and Nagar Haveli
      { id: 2, name: 'Daman' }, // Capital of Daman district
      { id: 3, name: 'Diu' }, // Capital of Diu district
      { id: 4, name: 'Amli' },
      { id: 5, name: 'Kachigam' },
      { id: 6, name: 'Bhimpore' },
      { id: 7, name: 'Kadaiya' },
      { id: 8, name: 'Marwad' },
      { id: 9, name: 'Naroli' },
      { id: 10, name: 'Samarvarni' },
    ],
  },
  {
    id: 32,
    name: 'Lakshadweep',
    cities: [
      { id: 1, name: 'Kavaratti' }, // Capital of Lakshadweep
      { id: 2, name: 'Agatti' },
      { id: 3, name: 'Amini' },
      { id: 4, name: 'Andrott' },
      { id: 5, name: 'Bitra' },
      { id: 6, name: 'Chetlat' },
      { id: 7, name: 'Kadmat' },
      { id: 8, name: 'Kalpeni' },
      { id: 9, name: 'Kiltan' },
      { id: 10, name: 'Minicoy' },
    ],
  },
  {
    id: 33,
    name: 'Delhi',
    cities: [
      { id: 1, name: 'New Delhi' }, // Capital of India
      { id: 2, name: 'Central Delhi' },
      { id: 3, name: 'East Delhi' },
      { id: 4, name: 'North Delhi' },
      { id: 5, name: 'South Delhi' },
      { id: 6, name: 'West Delhi' },
      { id: 7, name: 'North East Delhi' },
      { id: 8, name: 'North West Delhi' },
      { id: 9, name: 'South East Delhi' },
      { id: 10, name: 'South West Delhi' },
      { id: 11, name: 'Shahdara' },
    ],
  },
  {
    id: 34,
    name: 'Puducherry',
    cities: [
      { id: 1, name: 'Puducherry' }, // Capital of the Union Territory
      { id: 2, name: 'Karaikal' },
      { id: 3, name: 'Mahe' },
      { id: 4, name: 'Yanam' },
    ],
  },
  {
    id: 35,
    name: 'Jammu and Kashmir',
    cities: [
      { id: 1, name: 'Srinagar' }, // Summer Capital
      { id: 2, name: 'Jammu' }, // Winter Capital
      { id: 3, name: 'Anantnag' },
      { id: 4, name: 'Baramulla' },
      { id: 5, name: 'Udhampur' },
      { id: 6, name: 'Pulwama' },
      { id: 7, name: 'Kupwara' },
      { id: 8, name: 'Kathua' },
      { id: 9, name: 'Budgam' },
      { id: 10, name: 'Rajouri' },
      { id: 11, name: 'Poonch' },
      { id: 12, name: 'Ganderbal' },
      { id: 13, name: 'Kulgam' },
      { id: 14, name: 'Doda' },
      { id: 15, name: 'Shopian' },
      { id: 16, name: 'Reasi' },
      { id: 17, name: 'Samba' },
      { id: 18, name: 'Kishtwar' },
      { id: 19, name: 'Bandipora' },
    ],
  },
  {
    id: 36,
    name: 'Ladakh',
    cities: [
      { id: 1, name: 'Leh' }, // Administrative Capital
      { id: 2, name: 'Kargil' }, // Second largest town
      { id: 3, name: 'Diskit' },
      { id: 4, name: 'Dras' },
      { id: 5, name: 'Nubra' },
      { id: 6, name: 'Turtuk' },
      { id: 7, name: 'Tangtse' },
      { id: 8, name: 'Padum' },
      { id: 9, name: 'Hanle' },
      { id: 10, name: 'Changthang' },
    ],
  },
];

export enum HappeningType {
  SCHOOL_EVENT = 'event',
  SCHOOL_TRIP = 'trip',
  WORKSHOP = 'workshop',
}

export interface InteractionsType {
  user: string;
  userName: string;
  comments: string[];
  dates: string[];
  likeResponse?: boolean | undefined;
}
